import { Col, Container, Row } from "react-bootstrap";
import { NAVIGATION_MENU } from "../layout/AppSidebar";
import { useAuth } from "../contexts/auth";
import { Roles } from "../enums/Roles";
import { DashboardCard } from "../Components/DashboardCard";

export default function Dashboard() {
  const { loggedUser } = useAuth();

  return (
    <Container className="text-center justify-content-center align-items-start">
      <img
        className="my-3"
        height={200}
        src={require("../assets/logo/logo.png")}
        alt="Logo Get Move"
      />
      <Row className="justify-content-center">
        {NAVIGATION_MENU.filter((link) => !link.hide)
          .filter((link) => !link.admin || (loggedUser?.role ?? Roles.Host) > Roles.Host)
          .map((link) => (
            <Col key={link.key} sm={12} md={4} lg={3} className="mb-3">
              <DashboardCard
                title={link.title}
                icon={link.icon}
                link={link.url}
              />
            </Col>
          ))}
      </Row>
    </Container>
  );
}
